const roleToTitle = {
    1: 'Super Admin',
    2: 'Producer',
    3: 'Verifier'
}

const rolesToTheirActions = {
    2: ['ready_for_submission', 'rejected', 'verification_failed'],
    3: ['verification'],
}

export function isActingParticipant(role, action) {
    return !!rolesToTheirActions[role] && rolesToTheirActions[role].includes(action)
}

export function getTitle(role) {
    return roleToTitle[role]
}